// Affiliate links -> the order (Hub -> Afiliați). A visit with ?qk_aff=, ?qk_code= or UpPromote's
// ?sca_ref= is kept 30 days (the last click wins) and written on the cart as _qk_aff, with _qk_aff_at
// = the click; Shopify copies both to the order. Only with analytics + marketing consent, like the
// newsletter attribution; without it Hub still sees a purchase made in the same visit (landing URL).
const KEY = 'qk_aff', DAYS = 30, MARK = 'qk_aff_cart';
const PARAMS = [['qk_aff', /^[a-z0-9-]{1,40}$/i], ['qk_code', /^[A-Za-z0-9-]{2,40}$/], ['sca_ref', /^\d{3,12}(\.[A-Za-z0-9_-]{1,40})?$/]];
const readCookie = name => document.cookie.split('; ').find(c => c.startsWith(`${name}=`))?.slice(name.length + 1);
function consentAllowed() {
  const privacy = window.Shopify?.customerPrivacy;
  return Boolean(privacy?.analyticsProcessingAllowed() && privacy?.marketingAllowed());
}
function stored() {
  try {
    const s = JSON.parse(decodeURIComponent(readCookie(KEY) || ''));
    return s && typeof s.v === 'string' && Date.now() - Date.parse(s.at) < DAYS * 86400000 ? s : null;
  } catch { return null; }
}
async function write(attributes, mark) {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) });
  if (!response.ok) return;
  const cart = await response.json().catch(() => null);
  try { sessionStorage.setItem(MARK, `${String(cart?.token || '').split('?')[0]}|${mark}`); } catch {}
}
async function capture() {
  if (!consentAllowed()) {
    if (readCookie(KEY)) {
      document.cookie = `${KEY}=; Max-Age=0; Path=/; Secure; SameSite=Lax`;
      await write({ _qk_aff: '', _qk_aff_at: '' }, '');
    }
    return;
  }
  const url = new URL(location.href);
  for (const [name, valid] of PARAMS) {
    const value = url.searchParams.get(name);
    if (value && valid.test(value)) {
      document.cookie = `${KEY}=${encodeURIComponent(JSON.stringify({ v: `${name}=${value}`, at: new Date().toISOString() }))}; Max-Age=${DAYS * 86400}; Path=/; Secure; SameSite=Lax`;
      break;
    }
  }
  const s = stored();
  if (!s) return;
  const mark = `${s.v}|${s.at}`;
  const cart = decodeURIComponent(readCookie('cart') || '').split('?')[0];
  let done = '';
  try { done = sessionStorage.getItem(MARK) || ''; } catch {}
  if (cart && done === `${cart}|${mark}`) return;
  await write({ _qk_aff: s.v, _qk_aff_at: s.at }, mark);
}
function safeCapture() { void capture().catch(() => {}); }
document.addEventListener('visitorConsentCollected', safeCapture);
document.addEventListener('cart:change', safeCapture);
if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) safeCapture(); });
